import { render } from "./historyMsg.vue?vue&type=template&id=344c4a58"
import script from "./historyMsg.vue?vue&type=script&lang=js"
export * from "./historyMsg.vue?vue&type=script&lang=js"

import exportComponent from "F:\\MyProject\\8.142.129.201\\FCS\\admin\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__